import { getAnalytics } from 'firebase/analytics';
import { app } from '../Analytics/config';

// Initialize analytics only if consent is given
let analytics = null;

export const initializeAnalytics = (consentGiven, analyticsEnabled) => {
    if (consentGiven && analyticsEnabled && !analytics) {
        try {
            analytics = getAnalytics(app);
            console.log('Google Analytics initialized with consent');
        } catch (error) {
            console.error('Failed to initialize Google Analytics:', error);
        }
    }
};

export const getAnalyticsInstance = () => {
    return analytics;
};

// Google Analytics event tracking
export const trackEvent = (eventName, parameters = {}) => {
    if (analytics && window.gtag) {
        window.gtag('event', eventName, parameters);
    }
};

// Google Analytics page view tracking
export const trackPageView = (pagePath, pageTitle) => {
    if (analytics && window.gtag) {
        window.gtag('config', 'G-MPN00BT4KD', {
            page_path: pagePath,
            page_title: pageTitle
        });
    }
};

// Facebook Pixel tracking (if advertisement consent is given)
export const initializeFacebookPixel = (consentGiven, advertisementEnabled) => {
    if (consentGiven && advertisementEnabled && !window.fbq) {
        // Initialize Facebook Pixel
        (function (f, b, e, v, n, t, s) {
            if (f.fbq) return; n = f.fbq = function () {
                n.callMethod ?
                    n.callMethod.apply(n, arguments) : n.queue.push(arguments)
            };
            if (!f._fbq) f._fbq = n; n.push = n; n.loaded = !0; n.version = '2.0';
            n.queue = []; t = b.createElement(e); t.async = !0;
            t.src = v; s = b.getElementsByTagName(e)[0];
            s.parentNode.insertBefore(t, s);
        })(window, document, 'script',
            'https://connect.facebook.net/en_US/fbevents.js');

        // Replace with your actual Facebook Pixel ID
        window.fbq('init', 'YOUR_PIXEL_ID');
        window.fbq('track', 'PageView');
        console.log('Facebook Pixel initialized with consent');
    }
};

// Google Tag Manager integration
export const initializeGTM = (consentGiven, preferences) => {
    // Only initialize if consent is given AND at least one category is enabled
    const hasEnabledCategories = preferences.analytics || preferences.advertisement;
    if (consentGiven && hasEnabledCategories && !window.gtmInitialized) {
        // Initialize Google Tag Manager
        (function (w, d, s, l, i) {
            w[l] = w[l] || []; w[l].push({
                'gtm.start':
                    new Date().getTime(), event: 'gtm.js'
            }); var f = d.getElementsByTagName(s)[0],
                j = d.createElement(s), dl = l != 'dataLayer' ? '&l=' + l : ''; j.async = true; j.src =
                    'https://www.googletagmanager.com/gtm.js?id=' + i + dl; f.parentNode.insertBefore(j, f);
        })(window, document, 'script', 'dataLayer', 'GTM-WF6WPTD');

        // Set consent mode
        window.gtag('consent', 'default', {
            'analytics_storage': preferences.analytics ? 'granted' : 'denied',
            'ad_storage': preferences.advertisement ? 'granted' : 'denied',
            'functionality_storage': 'granted',
            'personalization_storage': 'denied',
            'security_storage': 'granted' // Always granted for necessary cookies
        });

        // Add GTM noscript tag to body
        addGTMNoscript();

        window.gtmInitialized = true;
        console.log('Google Tag Manager initialized with consent preferences');
    }
};

// Add GTM noscript tag to body
const addGTMNoscript = () => {
    const noscript = document.createElement('noscript');
    const iframe = document.createElement('iframe');
    iframe.src = 'https://www.googletagmanager.com/ns.html?id=GTM-WF6WPTD';
    iframe.height = '0';
    iframe.width = '0';
    iframe.style.display = 'none';
    iframe.style.visibility = 'hidden';
    noscript.appendChild(iframe);
    document.body.insertBefore(noscript, document.body.firstChild);
};

// Cookie management utilities
const getCookieDomain = () => {
    return '';
};

export const setCookie = (name, value, days) => {
    const expires = new Date();
    expires.setTime(expires.getTime() + (days * 24 * 60 * 60 * 1000));
    document.cookie = `${name}=${value};expires=${expires.toUTCString()};path=/${getCookieDomain()}`;
};

export const getCookie = (name) => {
    const nameEQ = name + "=";
    const ca = document.cookie.split(';');
    for (let i = 0; i < ca.length; i++) {
        let c = ca[i];
        while (c.charAt(0) === ' ') c = c.substring(1, c.length);
        if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
    }
    return null;
};

export const deleteCookie = (name) => {
    document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/${getCookieDomain()}`;
};

// Clear all tracking cookies when consent is withdrawn
export const clearTrackingCookies = () => {
    const trackingCookies = [
        '_ga',
        '_ga_*',
        '_fbp',
        '_gcl_au',
        'test_cookie',
        'lastExternalReferrer',
        'lastExternalReferrerTime',
        'topicsLastReferenceTime',
        '_gcl_ls'
    ];

    trackingCookies.forEach(cookieName => {
        deleteCookie(cookieName);
    });

    // Clear localStorage items that might contain tracking data
    const trackingKeys = ['persist:root'];
    trackingKeys.forEach(key => {
        if (key.startsWith('persist:')) {
            // Keep persist:root as it's necessary for app functionality
            return;
        }
        localStorage.removeItem(key);
    });
};

// Load Google Analytics script dynamically
export const loadGoogleAnalytics = (consentGiven, analyticsEnabled) => {
    if (consentGiven && analyticsEnabled && !window.gtag) {
        const script = document.createElement('script');
        script.async = true;
        script.src = 'https://www.googletagmanager.com/gtag/js?id=G-MPN00BT4KD';
        document.head.appendChild(script);

        window.dataLayer = window.dataLayer || [];
        function gtag() { window.dataLayer.push(arguments); }
        window.gtag = gtag;
        gtag('js', new Date());
        gtag('config', 'G-MPN00BT4KD', {
            anonymize_ip: true
        });

        console.log('Google Analytics script loaded');
    }
};
